import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {BreadcrumbItemModel} from '../subheader/_models/breadcrumb-item.model';
import {Observable} from 'rxjs';
import {SubheaderService} from '../subheader/_services/subheader.service';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';

@Component({
  selector: 'app-breadcrum',
  templateUrl: './breadcrum.component.html',
  styleUrls: ['./breadcrum.component.scss']
})
export class BreadcrumComponent implements OnInit {
  breadcrumbs$: Observable<BreadcrumbItemModel[]>;
  breadcrumbs: BreadcrumbItemModel[] = [];
  title$: Observable<string>;
  constructor(
    private subheader: SubheaderService,
    private cdr: ChangeDetectorRef,
    private titleService: Title,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.subheader.setDefaultSubheader();
    const initSubheader = () => {
      setTimeout(() => {
        this.subheader.updateAfterRouteChanges(this.router.url);
      }, 0);
    };
    initSubheader();
    this.breadcrumbs$ = this.subheader.breadCrumbsSubject.asObservable();
    this.breadcrumbs$.subscribe((res) => {
      this.breadcrumbs = res;
      // console.log(this.breadcrumbs);
      this.cdr.detectChanges();
      if (this.breadcrumbs.length) {
        // this.titleService.setTitle(this.breadcrumbs[0].title);
      }
    });
    this.title$ = this.subheader.titleSubject.asObservable();
  }

}
